export default httpClient => ({
    save: async (dados, token) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
        const response = await httpClient.post('/colunistas', dados, { headers });
        console.log(dados)
        return {
            data: response.data
        }
    },
    update: async (dados, token) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
        const response = await httpClient.post('/colunistas/' + dados.get('id'), dados, { headers });
        return {
            data: response.data
        }
    },
    getById: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/colunistas/' + id, { headers });
        return {
            data: response.data
        }
    },
    getAll: async ({ token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/colunistas', { headers });
        return {
            data: response.data
        }
    },
    getAllSite: async () => {
        const response = await httpClient.get('/colunistas-site');
        return {
            data: response.data
        }
    },
    getNome: async ({ nome_url }) => {
        const response = await httpClient.get('/colunista/' + nome_url);
        return {
            data: response.data
        }
    },
    delete: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/colunistas/' + id, { headers });
        return {
            data: response
        }
    },
    deletarImagem: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/deletar-imagem/' + id, { headers });
        return {
            data: response
        }
    }
});